'use client';
import { rem } from '@s7/styles';

var COMPONENT_ID = "Typography";
var DEFAULT_HEADING_SIZES = {
    xl1: rem(44),
    lg1: rem(32),
    md2: rem(28),
    md1: rem(24),
    sm1: rem(20),
    xs3: rem(18),
    xs2: rem(16),
    xs1: rem(14)
};
var DEFAULT_HEADING_HEIGHTS = {
    xl1: rem(48),
    lg1: rem(36),
    md2: rem(32),
    md1: rem(28),
    sm1: rem(28),
    xs3: rem(24),
    xs2: rem(24),
    xs1: rem(20)
};
var DEFAULT_TEXT_HEIGHTS = {
    lg1: rem(28),
    md1: rem(24),
    sm1: rem(20),
    xs3: rem(18),
    xs2: rem(16),
    xs1: rem(14)
};
var DEFAULT_TEXT_SIZES = {
    lg1: rem(18),
    md1: rem(16),
    sm1: rem(14),
    xs3: rem(13),
    xs2: rem(12),
    xs1: rem(10)
};
var DEFAULT_WEIGHTS = {
    semibold: 600,
    medium: 500,
    regular: 400
};
var defaultProps = {
    variants: {
        text: {
            size: "md1",
            weight: "regular",
            sizes: DEFAULT_TEXT_SIZES,
            heights: DEFAULT_TEXT_HEIGHTS,
            weights: DEFAULT_WEIGHTS
        },
        heading: {
            size: "md1",
            weight: "semibold",
            sizes: DEFAULT_HEADING_SIZES,
            heights: DEFAULT_HEADING_HEIGHTS,
            weights: DEFAULT_WEIGHTS
        }
    },
    variant: "text"
};

export { COMPONENT_ID, DEFAULT_HEADING_HEIGHTS, DEFAULT_HEADING_SIZES, DEFAULT_TEXT_HEIGHTS, DEFAULT_TEXT_SIZES, DEFAULT_WEIGHTS, defaultProps };
